import { render, staticRenderFns } from "./g-null.vue?vue&type=template&id=618eb8d6&scoped=true"
import script from "./g-null.vue?vue&type=script&lang=js"
export * from "./g-null.vue?vue&type=script&lang=js"
import style0 from "./g-null.vue?vue&type=style&index=0&id=618eb8d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618eb8d6",
  null
  
)

export default component.exports